import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var _templateObject;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';
import withApiData from '../services/withApiData';
import styled from 'styled-components';
import { hideModalLoader } from '../redux/modal';
import { performApiRequest } from '../redux/apiData';
import { GridWrapper } from '../styles/gridElements';
import LayoutBase from './shared/layout/LayoutBase';
import ArticleContent from './ArticleContent';
import ErrorBlock from './ErrorBlock';
import { getErrorBlockProps } from '../constants/errorMessages';
import ContentLoader from './shared/ui/ContentLoader';
import get from 'lodash.get';
var connectApiData = withApiData({
  article: 'getArticle'
}, function (ownProps) {
  var _ref = ownProps.modal ? ownProps : ownProps.match.params,
    projectSlug = _ref.projectSlug,
    env = _ref.env,
    articleSlug = _ref.articleSlug;
  return {
    article: {
      projectSlug: projectSlug,
      env: env,
      articleSlug: articleSlug
    }
  };
});
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    completeLoading: function completeLoading() {
      dispatch(hideModalLoader());
    },
    getNewArticle: function getNewArticle(projectSlug, env, articleSlug) {
      dispatch(performApiRequest('getArticle', {
        projectSlug: projectSlug,
        env: env,
        articleSlug: articleSlug
      }));
    }
  };
};
var Article = /*#__PURE__*/function (_PureComponent) {
  function Article() {
    _classCallCheck(this, Article);
    return _callSuper(this, Article, arguments);
  }
  _inherits(Article, _PureComponent);
  return _createClass(Article, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        modal = _this$props.modal,
        article = _this$props.article,
        completeLoading = _this$props.completeLoading;
      if (modal && article.data) {
        completeLoading();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      var _this$props2 = this.props,
        modal = _this$props2.modal,
        article = _this$props2.article,
        completeLoading = _this$props2.completeLoading,
        projectSlug = _this$props2.projectSlug,
        env = _this$props2.env,
        articleSlug = _this$props2.articleSlug,
        getNewArticle = _this$props2.getNewArticle;
      var oldArticle = oldProps.article;
      if (modal && !oldArticle.data && article.data) {
        completeLoading();
      }
      if (oldProps.articleSlug !== articleSlug) {
        getNewArticle(projectSlug, env, articleSlug);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        article = _this$props3.article,
        settings = _this$props3.settings,
        modal = _this$props3.modal,
        planningObj = _this$props3.planningObj,
        _this$props3$renderWi = _this$props3.renderWidth,
        renderWidth = _this$props3$renderWi === void 0 ? 0 : _this$props3$renderWi,
        match = _this$props3.match;
      var pageNotFound = get(article, 'request.response.status') === 404;
      var title = article.data && settings ? "".concat(article.data.title, " - ").concat(settings.siteName) : undefined;
      var meta = article.data ? {
        metaTitle: title
      } : {};
      var layoutSettings = {
        hasHeader: true,
        hasFooter: true,
        hasMenu: true
      };
      return modal ? article.data ? __jsx(ArticleContent, {
        article: article.data,
        planningObj: planningObj || false,
        modal: true,
        renderWidth: renderWidth,
        "data-id": "components_Article_ArticleContent"
      }) : null : __jsx(LayoutBase, {
        settings: settings,
        layoutSettings: layoutSettings,
        renderWidth: renderWidth,
        title: title,
        meta: meta,
        "data-id": "components_Article_LayoutBase"
      }, article.data && !pageNotFound && __jsx(ArticleGridWrapper, {
        "data-id": "components_Article_ArticleGridWrapper"
      }, __jsx(ArticleContent, {
        article: article.data,
        modal: false,
        renderWidth: renderWidth,
        planningObj: false,
        "data-id": "components_Article_ArticleContent"
      })), article.request.networkStatus === 'loading' && __jsx(ContentLoader, {
        "data-id": "components_Article_ContentLoader"
      }), pageNotFound && __jsx(ErrorBlock, _extends({}, getErrorBlockProps(match, 'article', 404), {
        "data-id": "components_Article_ErrorBlock"
      })));
    }
  }]);
}(PureComponent);
export default withMatch(connectApiData(connect(null, mapDispatchToProps)(Article)));
var ArticleGridWrapper = styled(GridWrapper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 40rem 20rem 100rem 20rem;\n"])));